import EventBus from './Event';
import { preqUpdateHasSubmitted } from './api_client/api_prequalification';

class PaymentSuccess {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$messageSuccess = $(document.body).find('[data-message-final]');
    console.log('this.$messageSuccess: ', this.$messageSuccess);
    this.$messageUpdating = $(document.body).find('[data-message-updating]');
    console.log('this.$messageUpdating: ', this.$messageUpdating);

    this.$messageSuccess.hide();

    this.referrer = document.referrer;

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.onLoadUser.bind(this));
  }

  async onLoadUser() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    if (this.referrer === 'https://buy.stripe.com/') {
      console.log('Stripe payment success');
      const preq_owner_user = window.grapp.user.auth.email;
      const updateReq = await preqUpdateHasSubmitted(preq_owner_user);
      if (updateReq.success) {
        this.$messageSuccess.show();
      } else {
        this.$messageSuccess.text('An error occurred while updating your prequalification. Please contact us at hello@goodrootshomes.com to verify your payment.');
        this.$messageSuccess.show();
        console.error('Error updating prequalification hasSubmitted');
      }
      this.$messageUpdating.hide();
    } else {
      this.$messageSuccess.text('An error occurred while updating your prequalification. Please contact us at hello@goodrootshomes.com to verify your payment.');
      this.$messageSuccess.show();
      this.$messageUpdating.hide();
    }
  }

  static init() {
    $('[data-js-component="payment_success"]').each((i, el) => new PaymentSuccess(el));
  }
}

PaymentSuccess.init();
